import { createSlice } from '@reduxjs/toolkit';
import {
    getAllFacilities,
    getAllBuyerOriganizations,
    getAllSupplierrOriganizations,
    getFilteredBuyerSupplier,
    getFacilityByID,
    getAllInvestorFacilityByOrgID,
    getDashboardDetailsByFacilityID,
    getLiveFacilityDetailsByID,
    getTransactionDetailsWithPagination,
    getBuyerInsights,
    getDocumentsByTransactionID,
    getSupplierInsights,
    getAllMasterInvestorFacilities,
    updateMasterInvestorFacility,
    getTotalTransactionValues,
    getAllRecentEvents,
    getTotalYieldByID,
    getBuyersSuppliersMapData,
    getBuyerSupplierInsightsMetrics,
    getAmountFundedTillDate,
    getBuyerAverageCreditLimit,
    getFacilityByOrgID,
} from '../actions/facilityApi';

export const facilitySlice = createSlice({
    name: 'facility',
    initialState: {
        isLoading: false,
        error: null,
        facilityTypeList: [],
        facilitiesAggregation: {},
        createInvesterStep1: {
            investorType: '',
            investorID: '',
            investorName: '',
            profile: {},
            investorFacilityName: '',
            isCloneVisible: false,
        },
        createInvesterStep3: {
            linkToMasterInvestor: '',
            facilityID: '',
            profile: {},
            amount: 0,
            contribution_percentage: 0,
        },
        buyerOrgList: [],
        supplierOrgList: [],
        filteredBuyerSupplier: {},
        facilityData: {},
        facilitytabList: [],
        investorDashboard: {},
        allFacilityCursor: 0,
        allFacilityHas_Next: false,
        isAllFacilityLoading: false,
        LiveFacilityDetailsByID: {},
        nextPageTransactionInsight: {},
        prevPageTransactionInsight: [],
        inSightList: [],
        buyerInsights: [],
        auditMileStone: {},
        documentsByTransactionID: {},
        supplierInsights: [],
        investorFacilityUlid: '',
        investorFacilityName: {},
        mInvFacilitiesList: [],
        totalTransactionValues: {},
        allRecentEvents: [],
        totalYieldByID: {},
        buyersSuppliersMapData: [],
        buyerSupplierInsightsMetrics: {},
        amountFundedTillDate: {},
        buyerAverageCreditLimit: {},
        facilityByOrgID: {},
    },
    reducers: {
        updateInvertorStep1: (state, action) => {
            state.createInvesterStep1 = { ...action.payload };
        },
        updateInvertorStep3: (state, action) => {
            state.createInvesterStep3 = { ...action.payload };
        },

        updateAuditMileStone: (state, action) => {
            state.auditMileStone = action.payload;
        },
        getInvestoeFacilityUlid: (state, action) => {
            state.investorFacilityUlid = action.payload;
        },
        searchAllFacility: (state, action) => {
            state.facilityTypeList = action.payload;
        },
        getInvestorFacilityName: (state, action) => {
            state.investorFacilityName = action.payload;
        },
        updatePrevTransactionInsight: (state, action) => {
            state.prevPageTransactionInsight = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllFacilities.pending, (state) => {
                state.isAllFacilityLoading = true;
            })
            .addCase(getAllFacilities.fulfilled, (state, action) => {
                if (action.payload.isSearch) {
                    state.facilityTypeList = action.payload.facilityList;
                } else {
                    // If isSearch is false, merge the arrays and remove duplicates
                    const existingFacilitiesSet = new Set(
                        (state.facilityTypeList || []).map((facility) => facility.fm_id)
                    );
                    const newFacilities = action.payload.facilityList.filter(
                        (facility) => !existingFacilitiesSet.has(facility.fm_id)
                    );

                    state.facilityTypeList = [...state.facilityTypeList, ...newFacilities];
                }
                state.isAllFacilityLoading = false;
                state.facilitiesAggregation = action.payload.facilitiesAggregation;
                state.allFacilityCursor = action.payload.nextCursor;
                state.allFacilityHas_Next = action.payload.has_next;
            })
            .addCase(getAllFacilities.rejected, (state, action) => {
                state.isAllFacilityLoading = false;
                state.error = action.payload;
            })
            .addCase(getAllBuyerOriganizations.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getAllBuyerOriganizations.fulfilled, (state, action) => {
                state.isLoading = false;
                const payload = action.payload;
                const sortedArray =
                    payload && payload.slice().sort((a, b) => a.organization_name.localeCompare(b.organization_name));
                state.buyerOrgList = sortedArray;
            })
            .addCase(getAllBuyerOriganizations.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(getAllSupplierrOriganizations.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getAllSupplierrOriganizations.fulfilled, (state, action) => {
                state.isLoading = false;
                state.supplierOrgList = action.payload;
            })
            .addCase(getAllSupplierrOriganizations.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(getFilteredBuyerSupplier.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getFilteredBuyerSupplier.fulfilled, (state, action) => {
                state.isLoading = false;
                state.filteredBuyerSupplier = action.payload;
            })
            .addCase(getFilteredBuyerSupplier.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(getFacilityByID.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getFacilityByID.fulfilled, (state, action) => {
                state.isLoading = false;
                state.facilityData = action.payload;
            })
            .addCase(getFacilityByID.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                state.facilityData = {};
            })
            .addCase(getDashboardDetailsByFacilityID.fulfilled, (state, action) => {
                state.isLoading = false;
                state.investorDashboard = action.payload;
            })
            .addCase(getAllInvestorFacilityByOrgID.fulfilled, (state, action) => {
                state.isLoading = false;
                state.facilitytabList = action.payload;
            })
            .addCase(getLiveFacilityDetailsByID.fulfilled, (state, action) => {
                state.isLoading = false;
                state.LiveFacilityDetailsByID = action.payload;
            })
            .addCase(getTransactionDetailsWithPagination.fulfilled, (state, action) => {
                state.isLoading = false;
                state.nextPageTransactionInsight = action.payload.nextPage;
                state.inSightList = action.payload.payload;
            })
            .addCase(getBuyerInsights.fulfilled, (state, action) => {
                state.isLoading = false;
                state.buyerInsights = action.payload;
            })
            .addCase(getDocumentsByTransactionID.fulfilled, (state, action) => {
                state.isLoading = false;
                state.documentsByTransactionID = action.payload;
            })
            .addCase(getSupplierInsights.fulfilled, (state, action) => {
                state.isLoading = false;
                state.supplierInsights = action.payload;
            })
            .addCase(getAllMasterInvestorFacilities.fulfilled, (state, action) => {
                state.isLoading = false;
                state.mInvFacilitiesList = action.payload;
            })
            .addCase(updateMasterInvestorFacility.fulfilled, (state, action) => {
                /* no-op */
            })
            .addCase(getTotalTransactionValues.fulfilled, (state, action) => {
                state.totalTransactionValues = action.payload;
            })
            .addCase(getAllRecentEvents.fulfilled, (state, action) => {
                state.allRecentEvents = action.payload;
            })
            .addCase(getTotalYieldByID.fulfilled, (state, action) => {
                state.totalYieldByID = action.payload;
            })
            .addCase(getBuyersSuppliersMapData.fulfilled, (state, action) => {
                state.buyersSuppliersMapData = action.payload;
            })
            .addCase(getBuyerSupplierInsightsMetrics.fulfilled, (state, action) => {
                state.buyerSupplierInsightsMetrics = action.payload;
            })
            .addCase(getAmountFundedTillDate.fulfilled, (state, action) => {
                state.amountFundedTillDate = action.payload;
            })
            .addCase(getBuyerAverageCreditLimit.fulfilled, (state, action) => {
                state.buyerAverageCreditLimit = action.payload;
            })
            .addCase(getFacilityByOrgID.fulfilled, (state, action) => {
                state.facilityByOrgID = action.payload;
            });
    },
});

export const {
    updateInvertorStep1,
    updateInvertorStep3,
    updateAuditMileStone,
    getInvestoeFacilityUlid,
    searchAllFacility,
    getInvestorFacilityName,
    updatePrevTransactionInsight,
} = facilitySlice.actions;
export default facilitySlice.reducer;
